module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Developer Dashboard"},"fr":{"title":"Developer Dashboard"},"it":{"title":"Pannello di controllo sviluppatore"}}')
  delete Component.options._Ctor
}
